import React, { useState, useEffect } from 'react';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import { toast } from 'react-toastify';
import CompanyForm from '../components/CompanyForm';
import { useForm } from 'react-hook-form';
import Loading from '../../common/Loading';
import { useTranslation } from 'react-i18next';
import Button from '../../common/Button';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { saveCompany } from '../../../reducers/companyReducer';
import { getCompanyById } from '../../../api/companyApi';

export interface AddCompanyProps {
  done: (savedCompany?: any) => void;
  id?: string;
  cancel: () => void;
}

function AddCompany({ done, id, cancel }: AddCompanyProps) {
  const dispatch = useAppDispatch();
  const companyTypes = useAppSelector((state) => state.companyTypes);

  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    getValues,
    setValue,
  } = useForm();

  const [file, setFile] = useState<any>();
  const [company, setCompany] = useState<any>();
  const [defaultCompanyType, setDefaultCompanyType] = useState<any>();

  useEffect(() => {
    if (companyTypes) {
      setDefaultCompanyType(companyTypes.find((x: any) => x.isDefault));
    }
  }, [companyTypes]);

  useEffect(() => {
    if (id) {
      getCompanyById(id).then((d) => {
        setCompany(d);
      });
    } else {
      setCompany({ id: '' });
    }
  }, [id]);

  const setDomains = (domains: string[]) => {
    setCompany({ ...company, domains });
  };

  const onSubmit = (data: any) => {
    dispatch(saveCompany({ ...company, ...data, file }))
      .unwrap()
      .then((savedCompany: any) => {
        toast.success(t('Company saved'));
        done(savedCompany);
      })
      .catch(() => {
        toast.error(t('Failed to save company'));
      });
  };

  return company ? (
    <>
      <SlideoutLayout
        title={`${id ? t('Edit company') : t('Add company')}`}
        cancel={cancel}
        bar={
          <Button
            type="submit"
            text={t('Save')}
            className="btn btn-primary"
            onClick={handleSubmit(onSubmit)}
            testId="save-company-button"
          />
        }
      >
        <CompanyForm
          company={company}
          companyTypes={companyTypes || []}
          defaultCompanyType={defaultCompanyType}
          register={register}
          errors={errors}
          control={control}
          getValues={getValues}
          setValue={setValue}
          columnCssClass="col-12"
          setFile={setFile}
          setDomains={setDomains}
        />
      </SlideoutLayout>
    </>
  ) : (
    <Loading />
  );
}

export default AddCompany;
